import { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Help } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';
import { Outlet } from '@mint/routing';

import { CurrencyManagementInfoDialog } from '../../components/molecules/CurrencyManagementInfoDialog.jsx';
import { DataFileStepper } from '../../components/molecules/DataFileStepper.jsx';
import { Navbar } from '../../components/molecules/Navbar.jsx';
import { ContextPanel } from '../../components/organisms/ContextPanel/ContextPanel.jsx';
import { TakeOverDialog } from '../../components/organisms/TakeOverDialog/TakeOverDialog.jsx';
import { DataFileProvider } from '../../contexts/DataFileContext/index.jsx';
import { useImportHubV2 } from '../../hooks/ff/index.js';

export function DataFileLayout() {
  const { t } = useTranslation('@myn/import-hub');
  const [isCurrencyInfoDialogOpen, setIsCurrencyInfoDialogOpen] =
    useState(false);

  const isImportHubV2 = useImportHubV2();

  return (
    <DataFileProvider>
      <TakeOverDialog />
      <Navbar />
      <ContextPanel />
      <Button
        variant="text"
        size="small"
        onClick={() => setIsCurrencyInfoDialogOpen(true)}
        className="mb-6 self-start pl-0 hover:bg-transparent focus:bg-transparent active:bg-transparent"
        data-dd-action-name="Learn more about currency management"
      >
        <Help className="size-4" />
        {t('Learn more about currency management')}
      </Button>
      <DataFileStepper />
      <Outlet />
      {isCurrencyInfoDialogOpen && (
        <CurrencyManagementInfoDialog
          onClose={() => setIsCurrencyInfoDialogOpen(false)}
          isImportHubV2={isImportHubV2}
        />
      )}
    </DataFileProvider>
  );
}
